<template>
    <div class="archive">
        <div class="columns">
            <div class="column is-3"  style="text-align:center;">
                <Datepicker/>
            </div>
            <div class="column">
                <div class="text_container">
                    <span class="title is-5">{{year_path}}年{{month_path}}月{{day_path}}日</span> {{message_length}}文字
                    <p v-if="feeling">{{feeling}} {{feeling_score}}点</p>
                    <p v-if="wetherInfo.city">@{{this.wetherInfo.city}} 気温{{this.wetherInfo.temp}}度 {{this.wetherInfo.condition}} 気圧{{this.wetherInfo.pressure}}hPa</p>
                    <div class="message">{{message}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import Datepicker from '@/components/Datepicker.vue'
export default {
    name: 'home',
    components: {
        Datepicker
    },
    data() {
        return{
        message: 'この日は書いていません',
        windowSize: 0,
        message_length: 0,
        day_counts: [],
        year_path: '',
        month_path: '',
        day_path: '',
        wetherInfo: [],
        feeling: null,
        feeling_score: null
        }
    },
    computed:{
        today(){
        return this.$store.getters.today_info;
        },
        user(){
        return this.$store.getters.user;
        }
    },
    mounted(){
        const title = "アーカイブ｜エモーションダイアリー"
        const description = "アーカイブ画面"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    },     
    watch: {
        '$route' (to) {
            this.$router.go(to.params.id)
        }
    },
    created(){
        this.windowSize = window.innerWidth
        var [ , , year_path, month_path, day_path] = location.pathname.split('/')
        this.year_path = year_path
        this.month_path = month_path
        this.day_path = day_path
        
        const getLastDay = (year, month) => {
            return new Date(year, month, 0).getDate();
        };
        const lastDay = getLastDay(year_path, month_path);

        //ループで日数を配列をセット
        for(var i = 1; i <= lastDay; i++){
            var set_data = {day:i, write:false}
            this.day_counts.push(set_data);
        }
        firebase.firestore().collection('diary_text').doc(this.user.uid).collection(year_path + '_' + month_path).doc(String(day_path)).get().then((doc) => {
            var data = doc.data()
            if(data){
                this.message = data.message
                this.message_length = data.length
                if(data.wetherInfo){
                    this.wetherInfo = data.wetherInfo
                }
                if(data.feeling){
                    switch(data.feeling) {
                        case 'happy':
                            this.feeling = '😆'
                            break;
                        case 'angry':
                            this.feeling = '😡'
                            break;
                        case 'sad':
                            this.feeling = '😢'
                            break;
                        case 'enjoy':
                            this.feeling = '😁'
                            break;
                        case 'bad':
                            this.feeling = '😩'
                            break;
                        case 'shock':
                            this.feeling = '😱'
                            break;
                        default:
                    }
                }
                if(data.feeling_score){
                    this.feeling_score = data.feeling_score
                }
            }
        }).then(()=>{
            if(window.innerWidth  > 800){
                firebase.firestore().collection('diary_text').doc(this.user.uid).collection(year_path + '_' + month_path).get().then(snapshot => {
                    snapshot.forEach(doc => {
                    var data = doc.data()
                    var index =  data.day -1
                    this.day_counts.splice(index, 1, {day:index + 1, write:true })
                    })
                });
            }
        });
    },
    
}
</script>

<style scoped>
.archive{
    min-height: 400px;
    padding: 10px
}
.text_container{
    max-width: 800px;
}
.day_counts{
    display: inline;
    font-size: 1.3em;
    padding:2px;
    font-weight: bold;
}
.message{
    padding-top: 40px;
    background-color: #FFFFFF;
    white-space: pre-wrap;
    word-wrap: break-word;
}
.month{
    text-align: center;
}

</style>

